import { useMemo } from "react";
import { Card, ComposedTextScoreCard } from "@ptsd/uikit";
import { useTranslation } from "react-i18next";
import { Text, View } from "tamagui";

import { api } from "~/utils/api";
import config from "~/config";

export const ScoreCard: React.FC<{ researchId: string }> = ({ researchId }) => {
  const { t } = useTranslation("slices");
  const [data] = api.phase.getInvolvement.useSuspenseQuery({
    researchId,
  });

  const exportUrl = useMemo(() => {
    const url = new URL("/export/slices-xlsx", config.API_URL);
    url.searchParams.append("researchId", researchId);
    return url;
  }, [researchId]);

  return (
    <Card
      shadow="md"
      flex={3}
      width="100%"
      maxWidth={344}
      gap={"$7.5"}
      paddingVertical={"$10"}
      paddingHorizontal={"$4.2"}
      alignItems="flex-start"
    >
      <View gap={"$3"}>
        <Card
          alignSelf="center"
          paddingVertical={"$2"}
          paddingHorizontal={"$2"}
          borderRadius={"$4.5"}
          variant="borderless"
          backgroundColor={"#F3F8F7"}
          minWidth={160}
          maxWidth={260}
        >
          <Text
            fontFamily={"$subtitle"}
            fontWeight={"$3"}
            fontSize={"$9"}
            lineHeight={"$9"}
            display="flex"
            flexWrap="wrap"
            justifyContent="center"
          >
            <Text
              data-id="score-card-active-patients"
              color={"$gray-primary-900"}
            >
              {data?.patients.activeOnAll}
            </Text>
            <Text data-id="score-card-total-patients" color={"$gray-100"}>
              /{data?.patients.total}
            </Text>
          </Text>
        </Card>

        <View gap={"$1"}>
          <Text
            data-id="score-card-title"
            textAlign="center"
            fontFamily={"$subtitle"}
            fontWeight={"$6"}
            fontSize={"$4"}
            lineHeight={"$4"}
            color={"$gray-primary-900"}
          >
            {t("results.score-card.title")}
          </Text>

          <Text
            data-id="score-card-description"
            textAlign="center"
            fontFamily={"$body"}
            fontWeight={"$4"}
            fontSize={"$3"}
            lineHeight={"$3"}
            color={"$gray-800"}
          >
            {t("results.score-card.description")}
          </Text>
        </View>
      </View>

      <ComposedTextScoreCard.DownloadBtn
        href={exportUrl.href}
        data-id="score-card-button-download"
      >
        {t("results.score-card.get-results-button")}
      </ComposedTextScoreCard.DownloadBtn>
    </Card>
  );
};
